<template>
  <MainLayout page-name="fees-for-security-master">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="preparation" @click="clickPreparation">料金マスタ準備</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
        @clear="clickClear"
        category="master"
      >
        <ChargeYear v-model="simpleSearchFormModel.charge_year" ref="childChargeYear" label="料金年度" prop="charge_year" :searchCond="true" :initialize="true" :required="true" tableType="SECURITY" yearType = "reference" mode = "this" selectedIndex="0"/>
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :default-sort="{ prop: 'route_code', order: 'descending' }"
      :selectable="deletable"
      :multiSelect="false"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <RouteCodeColumn />
        <FeeColumn label="旅客単価" prop="passenger_charge" :formatter="formatterPassengerCharge" />
        <FeeColumn label="貨物単価" prop="cargo_charge" :formatter="formatterCargoCharge" />
        <DateTimeColumn label="更新日時" prop="updated_on" />
        <BlankColumn />
        <!-- <MenuColumn @copy="copyRow" :cbdelete="deleteRow" :deletable="deletable" /> -->
      </template>
    </Table>
    <FeesForSecurityMasterPreparationDialog
      :visible.sync="preparationDialogVisible"
      @refresh="refreshSearch"
    />
    <FeesForSecurityMasterEditDialog
      :visible.sync="editDialogVisible"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import ChargeYear from '@/components/molecules/form/select/ChargeYear.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import RouteCodeColumn from '@/components/molecules/table/RouteCodeColumn.vue'
import FeeColumn from '@/components/molecules/table/FeeColumn.vue'
import DateTimeColumn from '@/components/molecules/table/DateTimeColumn.vue'

import BlankColumn from '@/components/molecules/table/BlankColumn.vue'
// import MenuColumn from '@/components/molecules/table/MenuColumn.vue'
import FeesForSecurityMasterPreparationDialog from '@/components/pages/feeMaster/feesForSecurityMaster/FeesForSecurityMasterPreparationDialog.vue'
import FeesForSecurityMasterEditDialog from '@/components/pages/feeMaster/feesForSecurityMaster/FeesForSecurityMasterEditDialog.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    ChargeYear,
    SimpleSearch,
    Table,
    RouteCodeColumn,
    FeeColumn,
    DateTimeColumn,
    BlankColumn,
    // MenuColumn,
    FeesForSecurityMasterPreparationDialog,
    FeesForSecurityMasterEditDialog
  },
  mixins: [
  ],
  data () {
    return {
      title: '保安料金マスタ',
      tableData: [],
      simpleSearchFormModel: {
        charge_year: ''
      },
      currentRow: {},
      preparationDialogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('feesForSecurityMasterSearchCond')
  },
  methods: {
    clickPreparation () {
      this.preparationDialogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('feesForSecurityMasterSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    clickClear () {
      this.$set(this.simpleSearchFormModel, 'charge_year', this.$refs.childChargeYear.options[0].value)
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('feesForSecurityMasterSearchCond'))
      this.$axios
        .get('/search-fees-for-security-master', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch (chargeYear) {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForSecurityMasterSearchCond'))
      if (!searchCond) {
        this.$set(this.simpleSearchFormModel, 'charge_year', chargeYear)
        sessionStorage.setItem('feesForSecurityMasterSearchCond', JSON.stringify(this.simpleSearchFormModel))
      } else {
        this.$set(this.simpleSearchFormModel, 'charge_year', searchCond.charge_year)
      }

      this.search()
    },
    // clickRow (row, column, event) {
    //   this.currentRow = row
    //   this.editDialogVisible = true
    // },
    clickRow (row, table) {
      this.currentRow = row
      this.editDialogVisible = true
      this.tableData = table
    },
    // copyRow (row) {
    //   const currentRow = { ...row }
    //   if (parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm())) {
    //     currentRow.billing_ym = ''
    //   }
    //   this.currentRow = currentRow
    //   this.registerDialogVisible = true
    // },
    // deleteRow (row) {
    //   this.deleteRows([row])
    // },
    // async deleteRows (rows) {
    //   if (!(await this.$fcMessage.messageBox(this.title, 'CMN0003W'))) {
    //     return
    //   }

    //   this.$loadingMask.on()
    //   await this.$axios
    //     .delete('/fees-for-security', { data: rows })
    //     .then((res) => {
    //       this.$fcMessage.showMessage(res.data.message)
    //       this.search()
    //     })
    //     .catch((e) => {
    //       this.$loadingMask.off()
    //       if (e.response) {
    //         switch (e.response.status) {
    //           case 402:
    //             this.$fcMessage.showMessage(e.response.data.message, true)
    //             break
    //           default:
    //         }
    //       }
    //     })
    // },
    // deletable (row, index) {
    //   // 削除可能条件
    //   return !(parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm()) || row.regist_type === '1')
    // },
    formatterPassengerCharge (row, column) {
      if (row.passenger_charge !== null) {
        return String(row.passenger_charge).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    },
    formatterCargoCharge (row, column) {
      if (row.cargo_charge !== null) {
        return String(row.cargo_charge).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.dummy {
  display: none;
}
// th.billing-ym{
//   display: none;
// }
// td.billing-ym{
//   display: none;
// }
</style>
